import {
  baseFields,
  couponFields,
  discountedProductFields,
  FormModel,
  modifierDiscountFields,
  onlineFlags,
  PosFields,
  templateConstraintFields,
} from '../index'

export function getFormModelKeys(): (keyof FormModel)[] {
  return [
    ...baseFields,
    'discount',
    'perceivedValue',
    'priceCap',
    'discountScope',
    ...onlineFlags,
    ...discountedProductFields,
    ...modifierDiscountFields,
    'instoreRedemptionType',
    'availableCustomerSupport',
    'images',
    ...couponFields,
    'posFields',
    'productIds',
    ...templateConstraintFields,
  ]
}

export function getPosFieldKeys(): (keyof PosFields)[] {
  return [
    'instoreRedemptionType',
    'productIds',
    'instoreDiscountedProductIds',
    'onlineDiscountedProductIds',
    'instoreModifierDiscountIds',
    'onlineModifierDiscountIds',
    'instoreModifierDiscountsAdvanced',
    ...couponFields,
  ]
}
